import apiFetch from '../apiFetch'

export default function (dossierId, isHistorical, documentsSelected, documentHistoricalsSelected, token) {
  return apiFetch({ endPoint: `Document/MassiveDownload/Download?documentsSelected=${documentsSelected + '-' + documentHistoricalsSelected}&dossierId=${dossierId}&isHistorical=${isHistorical}`, parseBlobAndAssign: true, method: 'GET', body: null, token: token })
}
